export var API_ENDPOINTS = {
  CHILI_PIPER_TENANT_ID: "thomsonreuters",
  CHILI_PIPER_API_URL: "https://thomsonreuters.chilipiper.com/concierge-js/cjs/concierge.js",
  TIMEOUT_DURATION: 600000 // 10 minutes

};